import axios from 'axios'

var apiClient = axios.create({
    baseURL: null,
    headers: {},
    withCredentials: true, // Always send session cookie
})

export default apiClient;
